const HandlePaginateService = {

  /**
  * 
  * Handle pagination for list or search.
  *
  * @param {number} page - The page number to fetch.
  * @param {boolean} isSearch - Whether currently in search mode.
  * @param {Function} searchFn - Function to call for search pagination.
  * @param {Function} listFn - Function to call for list pagination.
   */
  paginate({ page, isSearch, searchFn, listFn }) {
    if (isSearch) {
      searchFn(page);
    } else {
      listFn(page);
    }
  }
}
export default HandlePaginateService;
